
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 233","transform":"translate(-3353 886)"}},[_c('circle',{attrs:{"data-name":"楕円形 3","cx":"16","cy":"16","r":"16","transform":"translate(3353 -886)","fill":"#c63129"}}),_c('path',{attrs:{"d":"M3369-870l-4 3.6h3v5.4h2v-5.4h3m3-10.8h-1v-1.8h-2v1.8h-8v-1.8h-2v1.8h-1a1.908 1.908 0 00-2 1.8v12.6a1.908 1.908 0 002 1.8h4v-1.8h-4v-9.9h14v9.9h-4v1.8h4a1.908 1.908 0 002-1.8v-12.6a1.908 1.908 0 00-2-1.8z","fill":"#fff"}})])])
          )
        }
      }
    